import { useEffect, useMemo, useState } from "react";

const FIFTEEN_MIN_MS = 15 * 60 * 1000;

// Handles: "2026-01-13 09:00:47.484" OR normal ISO
export function safeParseDate(value) {
  if (!value) return null;

  if (value instanceof Date) return value;

  if (typeof value === "string") {
    // If already ISO, Date can parse it
    if (value.includes("T")) {
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    }

    // Convert "YYYY-MM-DD HH:mm:ss.SSS" -> "YYYY-MM-DDTHH:mm:ss.SSSZ"
    // Assumption: server time is UTC. If you want local time, remove the "Z".
    const iso = value.replace(" ", "T") + "Z";
    const d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function useRowCountdown(createdAt, durationMs = FIFTEEN_MIN_MS) {
  const expiryMs = useMemo(() => {
    const created = safeParseDate(createdAt)?.getTime();
    if (!created) return null;
    return created + durationMs;
  }, [createdAt, durationMs]);

  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const remainingMs =
    expiryMs == null ? 0 : Math.max(0, expiryMs - now);

  const isExpired = expiryMs == null ? true : remainingMs === 0;

  const minutes = Math.floor(remainingMs / 60000);
  const seconds = Math.floor((remainingMs % 60000) / 1000);

  const label = isExpired
    ? "Expired"
    : `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return { label, isExpired, remainingMs };
}
